module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C128"
  }, [_c('span', {
    staticClass: "size_120"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("CAST")]), _vm._v(" OF CHARACTERS")])])]), _vm._v(" "), _c('table', {
    staticClass: "C190",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "T119_FirstRow"
  }, [_c('td', {
    staticClass: "T119_Column1"
  }, [_c('strong', [_vm._v("THE MAYORS")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("RICHARD J. “DICK” DALEY (DECEASED)")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Mayor of Chicago from 1955 to 1976.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JANE BYRNE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Mayor of Chicago from 1979 to 1983. First female mayor.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("HAROLD WASHINGTON (DECEASED)")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Mayor of Chicago from 1983 to 1987. First African-American mayor.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("RICHARD M. “RICH” DALEY")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Mayor of Chicago from 1989 to 2011. Firstborn son of Dick Daley.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE RIVALS")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("EDWARD “ED” BURKE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("South-side Irish-Catholic and second-generation machine politician. One of the two white leaders of the divisive Council Wars from 1983 to 1986. Chicago alderman for over forty years.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JANE BYRNE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("See “The Mayors” above.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE INNER CIRCLE")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("WILLIAM M. “BILL” DALEY")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Youngest brother of Rich Daley. Well-known political consigliore.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("MARGARET “MAGGIE” DALEY (DECEASED)")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Wife of Rich Daley. Founder of Gallery 37 and After School Matters.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("TIM DEGNAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Bridgeport native who some refer to as the fifth Daley brother.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("PATRICK HUELS")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Eleventh Ward alderman from Bridgeport from 1976 to 1997.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_c('span', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("JER")]), _vm._v("EMIAH JOYCE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former politician from the south side. Controversial businessman.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("FRANK KRUESI")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("University of Chicago policy wonk who liked to be near the political action.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE ADVISERS")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DAVID AXELROD")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Media guru and political adviser for Democratic politicians.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("RAHM EMANUEL")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Fund-raiser for Daley’s 1989 mayoral race who would become well-known in Chicago and in national political circles. Tight with the Daley brothers. Current mayor of Chicago.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("NED KENNAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Psychologist and political strategist who advised both Rich Daley and Jane Byrne.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOHN SCHMIDT")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Attorney with progressive political leanings. Expert on privatization.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DAVID WILHELM")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Campaign manager for Daley’s 1989 mayoral race. Democratic national chairman from 1993 to 1994.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE ALDERMEN")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("TIMOTHY “TIM” EVANS")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("African-American alderman from the south side who served as Harold Washington’s floor leader in the city council from 1983 to 1987.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("RICHARD “DICK” MELL")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Wheeler-dealer alderman. Father-in-law of Rod Blagojevich.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOE MOORE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("North-side alderman. One of the few independents in the city council.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("PATRICK O’CONNOR")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Longtime leader in the Chicago City Council.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DAVID ORR")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former north-side alderman. Interim mayor for one week after Harold Washington’s death. Cook County clerk for more than two decades after 1990.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("EUGENE SAWYER (DECEASED)")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("African-American alderman. Mayor of Chicago from 1987 to 1989.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_c('span', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("EDWARD")]), _vm._v(" “ED” VRDOLYAK")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former chair of the Cook County Democratic party known as Fast Eddie. Close ally of Ed Burke. Served a ten-month jail sentence in 2011 and 2012.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("WELL-KNOWN POLITICIANS")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("ROD BLAGOJEVICH")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former governor of Illinois who is now in prison. Son-in-law of Dick Mell.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("GEORGE W. BUSH")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Forty-third president of the United States. Spent his sixtieth birthday with Rich Daley at one of the mayor’s favorite Chicago restaurants.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("WILLIAM J. “BILL” CLINTON")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Forty-second president of the United States.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v(" JESSE JACKSON")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Civil rights activist and minister. Unelected player in Chicago politics for over forty years.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("MICHAEL “MIKE” MADIGAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Powerful speaker of the Illinois House of Representatives. Second-generation machine politician.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("BARACK OBAMA")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Forty-fourth president of the United States. First African-American president. First president from Chicago.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DAN ROSTENKOWSKI")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Second-generation machine politician. US congressman from 1959 to 1995. Old-school dealmaker. Close political ally of Dick Daley. Mentor of Bill Daley.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("POLITICOS")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("GERY CHICO")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Prominent attorney. Political bloodlines run from Rich Daley, Ed Burke, and Harold Washington.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOHN DALEY")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Eleventh Ward Democratic committeeman and Cook County Board commissioner. Younger brother of Rich Daley. Bridgeport native who never left.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("ALLISON DAVIS")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Prominent attorney. Former idealist who turned into a clout-heavy real estate developer. Raised $68 million from City of Chicago pension funds to do deals with Daley’s nephew Robert Vanecko.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DENNIS GANNON")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("President of the Chicago Federation of Labor.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("VALERIE JARRETT")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("African-American power player from Chicago with deep ties to Barack Obama. Political bloodlines run from Rich Daley and Harold Washington.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("EDWARD “ED” KELLY")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Machine politician and former superintendent of the Chicago Park District. Friend of Dick Daley.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DAWN CLARK NETSCH")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Independent Democratic politician and liberal law professor. First woman nominated for Illinois governor by a major party.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("WILLIAM “BILL” SINGER")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Attorney and former alderman who ran against Dick Daley for mayor in 1975. Chicago Public Schools board member from 1989 to 1990.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("TODD STROGER")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former president of the Cook County board. Son of and heir to the political office of John Stroger, a longtime African-American ally of the Daley family.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE CREATIVE CLASS")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("FOREST CLAYPOOL")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Political player with management skills: two-time mayoral chief of staff, superintendent of the Chicago Park District, president of the Chicago Transit Authority. Longtime friend of David Axelrod, Rahm Emanuel, and David Wilhelm.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("ARNE DUNCAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("CEO of Chicago Public Schools from 2001 until 2008 who then became US secretary of education. A basketball player, like his friends John Rogers Jr. and Barack Obama.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("EARNEST GATES")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("African-American housing advocate.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("FRANK GEHRY")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("World-famous architect.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_c('span', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("JULI")]), _vm._v("A STASCH")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Mayoral chief of staff and former commissioner of housing.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("CHARLIE TROTTER")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Gourmet chef and restaurant owner.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("ED UHLIR")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Park planner and architect.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("PAUL VALLAS")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("CEO of the Chicago Public Schools from 1995 to 2001.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("LOIS WEISBERG")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Commissioner of cultural affairs from 1989 to 2011. Friend of Maggie Daley. Political bloodlines run from Harold Washington.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("OPRAH WINFREY")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("One-of-a-kind talk show host.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE BUSINESSPEOPLE")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOHN BRYAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("CEO of Sara Lee Corporation from 1975 to 2000. Major philanthropic fund-raiser.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("LESTER CROWN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Civic leader and billionaire businessman.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("MIKE KOLDYKE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Well-known venture capitalist. Founder of the Golden Apple Foundation.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("CINDY PRITZKER")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Civic leader and member of family that owns hotels, real estate, and manufacturing companies.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JERRY REINSDORF")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Owner of the Chicago Bulls and the Chicago White Sox.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOHN ROGERS JR.")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Founder and CEO of Ariel Investments. African-American civic leader who is friends with Barack Obama, Arne Duncan, Valerie Jarrett, and the Daley family.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("PAT RYAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Founder of Aon Insurance. Chairman and CEO of Chicago’s 2016 Olympic Bid Committee. Longtime Daley supporter.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOHN WARNER")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Senior executive at Boeing Corporation.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("LAW ENFORCEMENT AND GOOD GOVERNMENT VIGILANTES")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("PATRICK FITZGERALD")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Tough federal prosecutor who arrived in Illinois in 2001.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_c('span', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("DAV")]), _vm._v("ID HOFFMAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Inspector general of Chicago from 2005 to 2009.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("MICHAEL SHAKMAN")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Attorney who in the 1970s sued to prevent the city and county from hiring and firing employees for political reasons, which became known as the Shakman Decrees.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C201"
  }, [_c('strong', [_vm._v("THE CONVICTED")])]), _c('td', {
    staticClass: "T119_Column2"
  })]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JON BURGE")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former Chicago police officer raised on the far south side of Chicago. Sentenced to four and a half years in prison in 2011 for lying about his role in torturing African-American suspects.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JOHN CANNATELLO")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Businessman sentenced in 2006 to twenty-seven months in jail for his role in the Hired Truck Scandal. The Cannatello family had two generations of ties to the Daley family.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("JAMES DUFF")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Businessman sentenced in 2006 to nearly ten years in jail for a fraud scheme against the City of Chicago. The Duff family had two generations of ties to the Daley family.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("AL SANCHEZ")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("A leader of the Hispanic Democratic Organization (HDO). Streets and Sanitation commissioner from the far south side found guilty of trading city jobs for political favors. Sentenced to two and a half years in prison in 2011 for his role in hiring fraud at city hall.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_Row"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("ROBERT SORICH")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("Former mayoral patronage chief and a native of Bridgeport. The Sorich family had two generations of ties to the Daley family. Sentenced to nearly four years in prison in 2006 for hiring fraud at city hall.")])])]), _vm._v(" "), _c('tr', {
    staticClass: "T119_LastRow"
  }, [_c('td', {
    staticClass: "C202"
  }, [_c('span', {
    staticClass: "size_70"
  }, [_vm._v("DONALD TOMCZAK")])]), _c('td', {
    staticClass: "T119_Column2"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_vm._v("City of Chicago water department boss and a native of Bridgeport. Sentenced to four years in prison in 2006 for his role in the Hired Truck Scandal.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeb91044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_CAST_OF.vue
// module id = 69
// module chunks = 0